// Redux/reducers/deliveryReducer.js
const initialState = {
    deliveries: [],
    currentDelivery: null,
    loading: false
};

// Load from localStorage on init
const loadDeliveriesFromStorage = () => {
    const stored = localStorage.getItem('hpos_deliveries');
    if (stored) {
        try {
            return JSON.parse(stored);
        } catch (e) {
            return [];
        }
    }
    return [];
};

// Save to localStorage helper
const saveDeliveriesToStorage = (deliveries) => {
    localStorage.setItem('hpos_deliveries', JSON.stringify(deliveries));
};

// Generate unique ID
const generateId = () => {
    return `DN_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

// Generate delivery number
const generateDeliveryNumber = () => {
    const year = new Date().getFullYear();
    const month = String(new Date().getMonth() + 1).padStart(2, '0');
    const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    return `DN-${year}${month}-${random}`;
};

export const DELIVERY_STATUS = {
    PENDING: "PENDING",
    READY: "READY",
    SHIPPED: "SHIPPED",
    DELIVERED: "DELIVERED",
    CANCELLED: "CANCELLED",
    PARTIAL: "PARTIAL"
};

export const deliveryReducer = (state = { ...initialState, deliveries: loadDeliveriesFromStorage() }, action) => {
    let newDeliveries;

    switch (action.type) {
        case "DELIVERIES_LOADING":
            return { ...state, loading: action.payload };

        case "GET_DELIVERIES":
            return { ...state, deliveries: loadDeliveriesFromStorage(), loading: false };

        case "SET_DELIVERIES":
            return { ...state, deliveries: action.payload || [], loading: false };

        case "GET_DELIVERY": {
            const delivery = loadDeliveriesFromStorage().find(d => (d.POID || d.id) === action.payload);
            return { ...state, currentDelivery: delivery, loading: false };
        }

        case "CREATE_DELIVERY": {
            const newDelivery = {
                ...action.payload,
                POID: generateId(),
                id: generateId(),
                deliveryNumber: generateDeliveryNumber(),
                status: DELIVERY_STATUS.PENDING,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            };
            newDeliveries = [newDelivery, ...loadDeliveriesFromStorage()];
            saveDeliveriesToStorage(newDeliveries);
            return { ...state, deliveries: newDeliveries, currentDelivery: newDelivery, loading: false };
        }

        case "UPDATE_DELIVERY": {
            const existingDeliveries = loadDeliveriesFromStorage();
            newDeliveries = existingDeliveries.map(d =>
                (d.POID === action.payload.id || d.id === action.payload.id)
                    ? { ...d, ...action.payload.data, updatedAt: new Date().toISOString() }
                    : d
            );
            saveDeliveriesToStorage(newDeliveries);
            return { ...state, deliveries: newDeliveries, loading: false };
        }

        case "UPDATE_DELIVERY_STATUS": {
            const existingDeliveries = loadDeliveriesFromStorage();
            newDeliveries = existingDeliveries.map(d =>
                (d.POID === action.payload.id || d.id === action.payload.id)
                    ? {
                        ...d,
                        status: action.payload.status,
                        trackingNumber: action.payload.trackingNumber || d.trackingNumber,
                        shippedAt: action.payload.status === DELIVERY_STATUS.SHIPPED ? new Date().toISOString() : d.shippedAt,
                        deliveredAt: action.payload.status === DELIVERY_STATUS.DELIVERED ? new Date().toISOString() : d.deliveredAt,
                        updatedAt: new Date().toISOString()
                    }
                    : d
            );
            saveDeliveriesToStorage(newDeliveries);
            return { ...state, deliveries: newDeliveries, loading: false };
        }

        case "DELETE_DELIVERY": {
            const existingDeliveries = loadDeliveriesFromStorage();
            newDeliveries = existingDeliveries.filter(d => (d.POID !== action.payload && d.id !== action.payload));
            saveDeliveriesToStorage(newDeliveries);
            return { ...state, deliveries: newDeliveries, loading: false };
        }

        default:
            return state;
    }
};